import { render, staticRenderFns } from "./MomoDeposit.vue?vue&type=template&id=6c306cb8"
import script from "./MomoDeposit.vue?vue&type=script&lang=js"
export * from "./MomoDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports